import { render, staticRenderFns } from "./procurementGreens.vue?vue&type=template&id=3484ece4&scoped=true"
import script from "./procurementGreens.vue?vue&type=script&lang=js"
export * from "./procurementGreens.vue?vue&type=script&lang=js"
import style0 from "./procurementGreens.vue?vue&type=style&index=0&id=3484ece4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3484ece4",
  null
  
)

export default component.exports